import { SVGProps } from 'react';

const ArrowLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="30"
    height="30"
    x="0"
    y="0"
    viewBox="0 0 48 48"
    xmlSpace="preserve">
    <g>
      <path
        d="m27.9 11.2 15.8 12c.5.4.5 1.2 0 1.6l-15.8 12c-.4.3-.8.2-1 .1-.4-.2-.5-.5-.5-.9v-6c0-.5-.5-1-1-1H5c-.5 0-1-.5-1-1v-8c0-.5.4-1 1-1h20.4c.5 0 1-.5 1-1v-6c0-.4.2-.7.5-.9.1-.1.5-.2 1 .1z"
        fill={props.fill}
        opacity="1"
        data-original={props.fill}></path>
    </g>
  </svg>
);
export default ArrowLogo;
